module.exports = __webpack_public_path__ + "img/31.d035c8a1.webp";